if (!customElements.get('rw-announcement-bar')) {
  customElements.define('rw-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const viewport = this.querySelector('.rw-announcement-viewport');
      const track = this.querySelector('.rw-announcement-track');
      const source = this.querySelector('[data-announcement-source]');
      const cycle = source.querySelector('.rw-announcement-cycle');
      const button = this.querySelector('.rw-announcement-pause');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const duplicate = element => {
        const copy = element.cloneNode(true);
        copy.classList.add('rw-announcement-copy');
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-announcement-source');
        copy.querySelectorAll('a, button, [tabindex]').forEach(link => link.setAttribute('tabindex', '-1'));
        copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
        });
        return copy;
      };
      const build = () => {
        source.replaceChildren(cycle);
        track.replaceChildren(source);
        this.dataset.motion = motion.matches ? 'reduced' : 'scroll';
        if (!motion.matches) {
          const width = cycle.getBoundingClientRect().width;
          if (!width || !viewport.clientWidth) return;
          const copies = Math.ceil(viewport.clientWidth / width) + 1;
          for (let index = 1; index < copies; index++) source.append(duplicate(cycle));
          const distance = source.getBoundingClientRect().width;
          this.style.setProperty('--rw-marquee-distance', `${distance}px`);
          this.style.setProperty('--rw-marquee-duration', `${distance / (Number(this.dataset.speed) || 45)}s`);
          track.append(duplicate(source));
        }
        this.dataset.ready = 'true';
      };
      let frame;
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(build);
      };
      const toggle = () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        const label = paused ? 'Resume announcements' : 'Pause announcements';
        button.setAttribute('aria-label', label);
        button.title = label;
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(viewport);
      motion.addEventListener('change', schedule);
      button.addEventListener('click', toggle);
      document.fonts.ready.then(() => { if (this.isConnected) schedule(); });
      build();
      this.cleanup = () => {
        cancelAnimationFrame(frame);
        observer.disconnect();
        motion.removeEventListener('change', schedule);
        button.removeEventListener('click', toggle);
      };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
